import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import Select from 'react-select';
import { required } from '../../../forms';

export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    {label && <ControlLabel>{label}</ControlLabel>}
    <FormControl {...input} type={type} />
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className="alert alert-warning">{warning}</p>))}
  </InputGroup>
);

const RenderSelectInput = ({ input, options, name, id, label }) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <Select
      id={id}
      name={name}
      options={options}
      value={input.value}
      onChange={value => input.onChange(value.value)}
      onBlur={value => input.onBlur(value.value)}
    />
  </FormGroup>
);

const MemberDetailForm = ({ onSubmit, initialValues, groups, handleRemove, isNew }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={values => {}}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => {
      const canDelete = !isNew;
      const saveLabel = isNew ? 'Add Member' : 'Edit Member';
      return (
        <div>
          <form onSubmit={handleSubmit}>
            <FormGroup>
              <Field
                name="first_name"
                type="text"
                component={renderBootstrapField}
                label="First Name"
                validate={required}
              />
              <Field
                name="last_name"
                type="text"
                component={renderBootstrapField}
                label="Last Name"
                validate={required}
              />
              <Field
                name="title"
                type="text"
                component={renderBootstrapField}
                label="Title"
                validate={required}
              />
            </FormGroup>
            <FormGroup>
              <Field
                name="group"
                type="text"
                component={RenderSelectInput}
                label="Group"
                options={groups}
                validate={required}
              />
            </FormGroup>
            <FormGroup>
              <Field name="email" type="text" component={renderBootstrapField} label="Email" />
              <Field
                name="phone_number"
                type="text"
                component={renderBootstrapField}
                label="Phone"
              />
            </FormGroup>
            <FormGroup>
              <ButtonToolbar>
                <Button disabled={pristine || submitting} bsStyle="info" type="submit">
                  <i className="fa fa-pencil fa-lg" /> {saveLabel}
                </Button>
                {canDelete && (
                  <Button bsStyle="info" onClick={handleRemove}>
                    <i className="fa fa-trash fa-lg" /> Remove from Tour
                  </Button>
                )}
              </ButtonToolbar>
            </FormGroup>
          </form>
        </div>
      );
    }}
  />
);

export default MemberDetailForm;



// WEBPACK FOOTER //
// src/routes/tours/components/MemberDetailForm.js